export default __webpack_public_path__ + "static/media/swift.a030128a.svg";